import MyJobsDetails from "./MyJobsDetails";
export default MyJobsDetails;
